<template>
  <BaseNoticeItem :button-text="$t('Update location')" :button-url="buttonUrl">
    <template #head>
      <strong>{{ $t('Work location conflict (international)') }}</strong>
    </template>
    <template #body>
      <p>
        {{
          $t(
            'Worksome requires the contract’s work location to match your registered location. If your profile location is correct, ask your client to update the hire’s location. For exceptions, your client or Worksome can request an override on your behalf.',
          )
        }}
      </p>
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import { computed } from 'vue'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import { useRedirectUri } from '@/composables/redirectUri'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const props = defineProps({
  complianceData: {
    type: Object,
    required: true,
  },
  hire: {
    type: Object,
    required: true,
  },
  isComplete: {
    type: Boolean,
    required: true,
  },
})

const { $t } = useTranslation()

const { redirectUri } = useRedirectUri()

const buttonUrl = computed(() => {
  const path = laravelNamedRoute(namedRoutes.frontend.user.profile.edit, {
    redirect_uri: redirectUri,
  })
  return `${path}#account-setup`
})
</script>
